<template>
  <div
    class="pt-4 bg-white-005 rounded-2xl w-full lg:w-2/5 flex flex-col"
    style="max-width: 486px; height: 440px"
  >
    <div class="px-2 flex justify-between items-center mb-3">
      <div class="ml-6 font-bold text-xl">DAO Rank</div>
      <ShareBtn class="mr-4" tip="DAO Rank"></ShareBtn>
    </div>

    <div class="px-2 flex-1 min-h-0">
      <Skeletor class="w-full h-full rounded" v-if="loading"></Skeletor>
      <div v-else>
        <router-link
          :to="`/dao/${item.daoPath}`"
          v-for="(item, i) in state.data"
          :key="i"
        >
          <div
            class="
              flex
              justify-between
              items-center
              h-16
              hover:bg-white-005
              rounded
              cursor-pointer
              p-4
            "
          >
            <div class="flex items-center">
              <SortTag :sortValue="i + 1"></SortTag>

              <UiImg
                :src="item.logo"
                class="
                  w-10
                  h-10
                  overflow-hidden
                  rounded-full
                  ml-4
                  mr-2
                  flex-shrink-0
                "
              ></UiImg>
              <div>
                <div class="line-clamp-1 mr-2">{{ item.name }}</div>
                <div
                  style="
                    background: rgba(255, 255, 255, 0.1);
                    border-radius: 8px;
                  "
                  class="px-2 text-white-070 rounded text-xs inline"
                >
                  {{ item.daoType }}
                </div>
              </div>
            </div>
            <div class="flex flex-col md:flex-row items-end md:items-start">
              <div class="font-bold">
                ${{ formatVal(item.totalUsd, { bit: 2, omit: true }) }}
              </div>
              <div
                class="font-bold text-right ml-2"
                :style="`color:${getRateColor(item.rate)}`"
              >
                {{ suffixNum((item.rate * 100).toFixed(2)) }}%
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>

    <router-link to="/leaderboard">
      <div
        class="
          flex
          items-center
          justify-center
          border-t border-white-010
          h-14
          hover:bg-white-005
        "
      >
        <div>See more <i class="iconfont icon-right"></i></div>
      </div>
    </router-link>
  </div>
</template>

<script setup>
import { defineProps, inject, onMounted, reactive, watch } from 'vue';
import RatioView from '@/components/RatioView.vue';
import UiImg from '@/components/UiImg.vue';
import { formatVal, getRateColor, suffixNum } from '@/utils';
import ShareBtn from './ShareBtn.vue';
import { useReqByBool } from '@/hooks';
import { queryDaoRank } from '@/api/common';
import { Skeletor } from 'vue-skeletor';
import SortTag from '@/components/SortTag.vue';
import { homeChains, homeTypes } from './constant';

const curChain = inject('curChain');
const homeState = inject('homeState');

const state = reactive({
  data: [],
});

const { loading, loadData } = useReqByBool(async () => {
  const res = await queryDaoRank(
    homeTypes[homeState.selectedType].value,
    homeChains[homeState.selectedChain].value,
    homeState.filterStatus,
    true,
  );
  state.data = res;
});

watch(
  () => [
    homeState.selectedType,
    homeState.selectedChain,
    homeState.filterStatus,
  ],
  () => {
    loadData();
  },
);

onMounted(() => {
  loadData();
});
</script>

<style lang="scss" scoped></style>
